module.exports = __webpack_public_path__ + "static/media/craterlake.52d46ce2.jpg";